module.exports = __webpack_public_path__ + "img/logo-facebook.fc482061.svg";